"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenConfigurationForTokenRoutes = exports.USER_TOKEN_STORAGE_KEY = exports.UNKNOWN_USER = exports.PUBLIC_TOKEN_USER = exports.NOT_LOGGED_IN_USER_ID = exports.NONCE_STORAGE_KEY = exports.LOGGED_IN_USER_COOKIE = exports.ID_TOKEN_STORAGE_KEY = exports.IDENTITY_CLIENT_ID = exports.CODE_VERIFIER_STORAGE_KEY = exports.AUTH_STATE_STORAGE_KEY = exports.AUTH_REDIRECT_URL_STORAGE_KEY = exports.AUTH_REDIRECT_URI_STORAGE_KEY = exports.AUTHORIZATION_CODE_STORAGE_KEY = exports.ANONYMOUS_TOKEN_STORAGE_KEY = void 0;
var _TokenEventNames = require("./TokenEventNames");
var _TokenRoutes = require("./TokenRoutes");
var _TokenSessionStorageKeys = require("./TokenSessionStorageKeys");
const AUTHORIZATION_CODE_STORAGE_KEY = exports.AUTHORIZATION_CODE_STORAGE_KEY = 'AuthCode';
// TODO: remove during refactor or major release
/**
 * @deprecated use TokenSessionStorageKeys instead
 */
const ANONYMOUS_TOKEN_STORAGE_KEY = exports.ANONYMOUS_TOKEN_STORAGE_KEY = 'PublicToken';
// TODO: remove during refactor or major release
/**
 * @deprecated use TokenSessionStorageKeys instead
 */
const USER_TOKEN_STORAGE_KEY = exports.USER_TOKEN_STORAGE_KEY = 'AuthToken';
const ID_TOKEN_STORAGE_KEY = exports.ID_TOKEN_STORAGE_KEY = 'AuthIdToken';
const AUTH_REDIRECT_URL_STORAGE_KEY = exports.AUTH_REDIRECT_URL_STORAGE_KEY = 'AuthRedirectUrl';
const AUTH_REDIRECT_URI_STORAGE_KEY = exports.AUTH_REDIRECT_URI_STORAGE_KEY = 'AuthRedirectUri';
const CODE_VERIFIER_STORAGE_KEY = exports.CODE_VERIFIER_STORAGE_KEY = 'AuthCodeVerifier';
const AUTH_STATE_STORAGE_KEY = exports.AUTH_STATE_STORAGE_KEY = 'AuthState';
const NONCE_STORAGE_KEY = exports.NONCE_STORAGE_KEY = 'AuthNonce';

/** User ID for user that is not logged in */
const NOT_LOGGED_IN_USER_ID = exports.NOT_LOGGED_IN_USER_ID = -1;

/** The name of the cookie that contains the logged in user. Coookie is used for the token validation. */
const LOGGED_IN_USER_COOKIE = exports.LOGGED_IN_USER_COOKIE = 'OriLoggedUser';

/** The `User` key value for the public token. */
const PUBLIC_TOKEN_USER = exports.PUBLIC_TOKEN_USER = 'anonymous';

/** The `User` key value if the user is unknown. */
const UNKNOWN_USER = exports.UNKNOWN_USER = 'unknown';

/**
 * Identity server client ID for authentication.
 */
const IDENTITY_CLIENT_ID = exports.IDENTITY_CLIENT_ID = 'SPADev';

/**
 * Token configuration under token routes. This is mainly used in TokenClient to differentiate configuration between instances by route
 */
const tokenConfigurationForTokenRoutes = exports.tokenConfigurationForTokenRoutes = {
  [_TokenRoutes.TokenRoutes.PUBLIC_ACCESS]: {
    eventName: _TokenEventNames.TokenEventNames.PUBLIC_ACCESS,
    sessionStorageKey: _TokenSessionStorageKeys.TokenSessionStorageKeys.PUBLIC_ACCESS
  },
  [_TokenRoutes.TokenRoutes.USER_ACCESS]: {
    eventName: _TokenEventNames.TokenEventNames.USER_ACCESS,
    sessionStorageKey: _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS
  }
};
